import Service from "./Service";
const baseurl = '/api/metodo-planificacion';
export default {
    index(params={}){
        return Service.get(`${baseurl}`, {
            params : params
        });
    }
}